import React from 'react';
import StoerkIdAPI from '../../../redux/stoerkID/StoerkIdAPI';
import { Skeleton } from '@mui/material';
import { WorkspaceAPI } from '../../../redux/stoerkID/StoerkIdAPI.model';

function WorkspaceName(props: { workspace: WorkspaceAPI | undefined }) {
  const { isLoading: isLoadingWorkspaces } =
    StoerkIdAPI.useGetAllWorkspaceQuery(undefined);
  return (
    <>
      {isLoadingWorkspaces ? (
        <Skeleton variant="text" width={80} />
      ) : (
        props.workspace?.name
      )}
    </>
  );
}

export default WorkspaceName;
